import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {

  Dialog,
  DialogContent,
} from '@mui/material';

import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import API_BASE_URL from '../../../../Constants';

import { RenderFields } from '../Customer/RenderFields';
import CustomerAccordion from '../Customer/accordion/CustomerAccordion';

import { GeneralInfoFields, AddressInfoFields, defaultTaxFormData } from './taxDetailsConfig';



const AddTaxDetailsModal = ({ open, handleClose }) => {



  const [taxDetail, setTaxDetail] = useState(defaultTaxFormData);
  const [isFullView, setIsFullView] = useState(false);



  const toggleFullView = () => {
    setIsFullView((prev) => !prev);
  };

  const resetFields = () => {
    setTaxDetail(defaultTaxFormData);
  };





  const handleSaveChanges = async () => {


    try {
      const response = await fetch(`${API_BASE_URL}/api/setup/taxdetails/create`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',

        },
        credentials: 'include',
        body: JSON.stringify(taxDetail),
      });
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      alert('Tax Detail updated successfully');
      handleModalClose();

    } catch (error) {
      console.error('Fetch error: ', error);
    }
  };


  const handleModalClose = () => {

    handleClose();
    resetFields();
  };

  const handleFieldChange = (e) => {
    const { name, value } = e.target;
    setTaxDetail((prev) => ({ ...prev, [name]: value }));
  };


  // Helper function to split fields array into two halves
  const splitFields = (fieldsArray) => {
    const midIndex = Math.ceil(fieldsArray.length / 2);
    return [fieldsArray.slice(0, midIndex), fieldsArray.slice(midIndex)];
  };









  return (
    <>
      <Dialog
        open={open}
        onClose={handleModalClose}
        maxWidth={false}
        PaperProps={{
          style: {
            width: isFullView ? '90%' : '1000px',
            maxHeight: '90vh',
            minHeight: '90vh',
          },
        }}
        fullWidth
        style={{ zIndex: 1400 }}
      >
        {/* Header */}
        <div className="sticky top-0 bg-white z-10">
          <div className="flex justify-between items-center p-4">
            {/* Left section: Back button and title */}
            <div className="flex items-center space-x-4 flex-grow">
              <button
                onClick={handleModalClose}
                className="p-2 rounded-full hover:bg-gray-200 transition"
                aria-label="Back"
              >
                <ArrowBackIcon />
              </button>
              <h2 className="text-2xl font-bold text-left">

                Add Tax Detail

              </h2>
            </div>
            {/* Right section: Expand/Shrink Button */}
            <button
              onClick={toggleFullView}
              className="p-2 rounded-full hover:bg-gray-200 transition"
              aria-label={'Expand Modal'}
            >
              {isFullView ? <FullscreenExitIcon /> : <FullscreenIcon />}
            </button>
          </div>
          <div className="flex space-x-4 p-4">
            <button
              onClick={handleSaveChanges}
              className="px-6 py-2 bg-sss-accent-yel text-sss-blue-sel font-bold rounded-md hover:bg-yellow-600 transition"
            >
              Save
            </button>

          </div>
        </div>

        <DialogContent
          dividers
          sx={{
            padding: 0,
            maxHeight: '90vh',
            overflowY: 'auto',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <div className="p-4 space-y-5 rounded-2xl">
            {/* General Info Accordion */}
            {(() => {
              const [generalInfoLeft, generalInfoRight] = splitFields(
                GeneralInfoFields
              );
              return (
                <CustomerAccordion label="General Info">
                  <div
                    className={`flex ${isFullView ? 'flex-row' : 'flex-col md:flex-row'
                      } gap-4`}
                  >
                    <div className="w-full">
                      <RenderFields
                        fields={generalInfoLeft}
                        formData={taxDetail}
                        handleChange={handleFieldChange}
                        readOnly={false}

                      />
                    </div>
                    <div className="w-full">
                      <RenderFields
                        fields={generalInfoRight}
                        formData={taxDetail}
                        handleChange={handleFieldChange}
                        readOnly={false}

                      />
                    </div>
                  </div>
                </CustomerAccordion>
              );
            })()}

            {/* Address Info Fields */}
            {(() => {
              const [generalInfoLeft, generalInfoRight] = splitFields(
                AddressInfoFields
              );
              return (
                <CustomerAccordion label="Address Info">
                  <div
                    className={`flex ${isFullView ? 'flex-row' : 'flex-col md:flex-row'} gap-4`}
                  >
                    <div className="w-full">
                      <RenderFields
                        fields={generalInfoLeft}
                        formData={taxDetail}
                        handleChange={handleFieldChange}
                        readOnly={false}

                      />
                    </div>
                    <div className="w-full">
                      <RenderFields
                        fields={generalInfoRight}
                        formData={taxDetail}
                        handleChange={handleFieldChange}
                        readOnly={false}

                      />
                    </div>
                  </div>
                </CustomerAccordion>
              );
            })()}


          </div>


        </DialogContent>
      </Dialog>
    </>
  );
};


AddTaxDetailsModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
};

export default AddTaxDetailsModal;
